var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning-a",
    d: "M15.7636364,2 C16.0047423,2 16.2359731,2.09577895 16.4064607,2.26626656 L21.7337334,7.59353929 C21.9042211,7.76402691 22,7.99525774 22,8.23636364 L22,15.7636364 C22,16.0047423 21.9042211,16.2359731 21.7337334,16.4064607 L16.4064607,21.7337334 C16.2359731,21.9042211 16.0047423,22 15.7636364,22 L8.23636364,22 C7.99525774,22 7.76402691,21.9042211 7.59353929,21.7337334 L2.26626656,16.4064607 C2.09577895,16.2359731 2,16.0047423 2,15.7636364 L2,8.23636364 C2,7.99525774 2.09577895,7.76402691 2.26626656,7.59353929 L7.59353929,2.26626656 C7.76402691,2.09577895 7.99525774,2 8.23636364,2 L15.7636364,2 Z M15.3870786,3.81818182 L8.61292142,3.81818182 L3.81818182,8.61292142 L3.81818182,15.3870786 L8.61292142,20.1818182 L15.3870786,20.1818182 L20.1818182,15.3870786 L20.1818182,8.61292142 L15.3870786,3.81818182 Z M11.3571757,14.9935393 C11.7121977,14.6385172 12.2878023,14.6385172 12.6428243,14.9935393 C12.9978464,15.3485614 12.9978464,15.9241659 12.6428243,16.279188 C12.2878023,16.6342101 11.7121977,16.6342101 11.3571757,16.279188 C11.0021536,15.9241659 11.0021536,15.3485614 11.3571757,14.9935393 Z M12,7.45454545 C12.4662144,7.45454545 12.8504611,7.80549108 12.9029748,8.25761716 L12.9090909,8.36363636 L12.9090909,12 C12.9090909,12.502077 12.502077,12.9090909 12,12.9090909 C11.5337856,12.9090909 11.1495389,12.5581453 11.0970252,12.1060192 L11.0909091,12 L11.0909091,8.36363636 C11.0909091,7.86155932 11.497923,7.45454545 12,7.45454545 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "warning-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#warning-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#warning-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#warning-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.70d9ba4379ec575089f5b00d553f5ad6.svg";
export { ForwardRef as ReactComponent };